<template>
  <div class="error-screen">
    <div class="error-screen__content">
      <div class="error-screen__icon">
        <slot name="icon">
          <img
            src="/surprise.svg"
            alt="Error Icon"
          />
        </slot>
      </div>
      <h2 class="error-screen__title">Помилка</h2>
      <p class="error-screen__message">
        З'єднання з закладом втрачено.<br />
        Зверніться до адміністратора.
      </p>
      <button
        class="error-screen__button"
        @click="refreshPage"
      >
        Оновити
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";

const router = useRouter();
const refreshPage = () => {
  router.push("/");
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

onMounted(() => {
  document.body.style.touchAction = "none"; // Прибираємо скрол
});

onUnmounted(() => {
  document.body.style.touchAction = "";
});

</script>

<style lang="scss" scoped>
.error-screen {
  position: absolute;
  z-index: 101;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--app-bg);
  color: #fff;
  text-align: center;
}

.error-screen__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-screen__icon {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}

.error-screen__title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: var(--text-head);
}

.error-screen__message {
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.2;
  color: var(--text-head);
  opacity: 0.9;
}

.error-screen__button {
  background-color: #ffca28;
  color: #434343;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
}

.error-screen__button:hover {
  background-color: #ffc107;
}
</style>
